import { all } from "redux-saga/effects";
import countrySaga from "./countrySaga";
import authSaga from "./authSaga";
import cartSaga from "./cartSaga";
import orderSaga from "./orderSaga";
import permissionSaga from "./permissionSaga";
import paymentSaga from "./paymentSaga";
import walletSaga from "./walletSaga";
export default function* rootSaga(getState) {
  yield all([
    countrySaga(),
    authSaga(),
    cartSaga(),
    orderSaga(),
    permissionSaga(),
    paymentSaga(),
    walletSaga(),
  ]);
}
